<template>
  <div class="item-row" v-bind:class="{ active: show }">
    <b-row>
      <b-col>
        <b-row class="item-name-cont">
          <b-form-checkbox size="lg" class="master-checkbox darkbg" :checked="shouldSelected(entity)" v-on:change="toggleGroup(entity, $event)">

          </b-form-checkbox>
          <b-col :aria-controls="entity.URI" @click="onShow" class="item-collapse-col">
            <span class="item-count">{{entity.sites.length}}</span>
            <span class="item-name">{{entity.name}}</span>
          </b-col>
        </b-row>

        <b-collapse :id="entity.URI" v-model="show" role="tabpanel">
          <b-row v-for="(site, index) in entity.sites" :key="index" class="child-item-row">
            <b-col class="subitem-col">
              <b-form-checkbox class="darkbg" :disabled="hideselector" size="sm" :checked="site.selected" v-on:change="toggleSite(entity,site, $event)">
                <span class="child-item-name">{{site.siteName}}</span>
              </b-form-checkbox>
            </b-col>
            <b-col>
              <span class="version-log">
                <span class="version-from">{{site.old_version}}</span>
                <span class="version-arrow" v-if="site.new_version">
                  <right-arrow-icon class="icon-default right-arrow"></right-arrow-icon>
                </span>
                <span class="version-to" v-if="site.new_version">{{site.new_version}}</span>
              </span>
            </b-col>
          </b-row>
        </b-collapse>

      </b-col>
    </b-row>
  </div>

</template>

<script>
import RightArrowIcon from "../../assets/rightarrow.svg";
export default {
  name: "updateItem",
  components: {
    RightArrowIcon
  },
  props: {
    entity: Object,
    hideselector: { type: Boolean, default: false }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    shouldSelected(entity) {
      let selectedSites = _.filter(entity.sites, { selected: true });
      if (entity.sites.length === selectedSites.length) {
        return true;
      }
      return false;
    },
    toggleGroup(group, value) {
      this.$emit("toggleGroup", {
        group,
        value
      });
    },
    toggleSite(group, site, isSelected) {
      this.$emit("toggleSite", {
        group,
        site,
        isSelected
      });
    },
    onShow() {
      
      this.show = !this.show;
    },
    onHide() {
      this.show = false;
    }
  }
};
</script>

<style scoped>
.item-row {
  cursor: pointer;
}
.custom-control {
  width: auto;
}
.master-checkbox {
  margin-top: 7px;
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/updateItem.vue